import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import { toast } from "react-toastify";
import CustomSelect from "../../../utils/CustomSelect";
import { Button, Form, Input, Label } from "../../../styles";
import Api from "../../../api/axios";
import { useInventoryContext } from "../../../context/inventory_context";
import { useUserContext } from "../../../context/user_context";
import { vatType } from "../../../utils/data";


const EditInventory = (props) => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({
    qty: '',
    selling_price: '',
    cost_price: '',
    batchNo: '',
    expiry_date: '',
    unit: '',
    qty_limit: '',
    vat_type: '',
  });

  const {
    showEditInventory, CloseEditInventory,
    getInventoryData, getInvtData
  } = useInventoryContext();

  const { btoken, stoken } = useUserContext();

  const {
    invtid,
    itemName,
    qty,
    selling_price,
    cost_price,
    batchNo,
    expiry_date,
    unit,
    qty_limit,
    vat_type } = props;

  useEffect(() => {
    if (props) {
      setformField({
        qty,
        selling_price,
        cost_price,
        batchNo,
        expiry_date,
        unit,
        qty_limit,
        vat_type
      });
    }
  }, [props]);

  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  const vat = vatType?.map(({ name, value }) => {
    return (
      { label: name, value: value }
    );
  });


  function submitFn(e) {
    e.preventDefault();
    if (
      formField.qty,
      formField.selling_price,
      formField.cost_price
    ) {
      setissending(true);
      const data = {
        btoken, stoken, invtid,
        qty: +formField.qty,
        selling_price: formField.selling_price,
        cost_price: formField.cost_price,
        batch_no: formField.batchNo,
        expiry_date: formField.expiry_date,
        unit: formField.unit,
        qty_limit: formField.qty_limit,
        vat_type: formField.vat_type,
      };

      Api.post(`/updateInventory`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            getInventoryData();
            getInvtData();
            CloseEditInventory();
          }
        })
        .catch(() => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }

  return (
    <>
      <Modal
        show={showEditInventory}
        onHide={CloseEditInventory}
        backdrop="static"
        keyboard={true}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text">
              Edit Inventory
            </h6>
          </Modal.Header>

          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>

              <Label> Item: </Label>
              <Input
                type="text"
                placeholder="e.g. Rice"
                disabled
                value={itemName}
              />

              <Label> Quantity: <span>*</span></Label>
              <Input
                type="number"
                name="qty"
                placeholder="e.g. 10"
                onChange={handleChange}
                required
                value={formField.qty}
              />

              <Label> Cost Price: <span>*</span></Label>
              <Input
                type="number"
                name="cost_price"
                placeholder="e.g. 1000"
                onChange={handleChange}
                required
                value={formField.cost_price}
              />

              <Label> Selling Price: <span>*</span></Label>
              <Input
                type="number"
                name="selling_price"
                placeholder="e.g. 1000"
                onChange={handleChange}
                required
                value={formField.selling_price}
              />

              <Label> Batch Number:</Label>
              <Input
                type="text"
                name="batchNo"
                placeholder="e.g. BC-100"
                onChange={handleChange}
                value={formField.batchNo}
              />

              <Label> Unit:</Label>
              <Input
                type="number"
                name="unit"
                placeholder="e.g. 10"
                onChange={handleChange}
                value={formField.unit}
              />

              <Label> Quantity Limit:</Label>
              <Input
                type="number"
                name="qty_limit"
                placeholder="e.g. 5"
                onChange={handleChange}
                value={formField.qty_limit}
              />

              <Label> Expiry Date:</Label>
              <Input
                type="date"
                name="expiry_date"
                onChange={handleChange}
                value={formField.expiry_date}
              />

              <Label> VAT Type: <span>*</span>
              </Label>
              <CustomSelect
                options={vat}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, vat_type: e.value }))}
                placeholder='Select VAT Type'
                value={formField.vat_type}
                required
              />

              <div className="col-md-10 mx-auto text-center mb-4">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Inventory Modal */}

      {/* <EditInventoryCategory
      /> */}
      {/* Edit Inventory Modal */}
    </>
  );
};

export default EditInventory;
